import request from '../../utilities/request';
import localStorageToken from '../../utilities/storage';

function list(page, query) {
  return request({
    url:    `/franchise/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params:  query
  });
};

function listAll() {
  return request({
    url:    `/franchise/listAll`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function find(id) {
  return request({
    url:    `/franchise/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
};

function save(values) {
  return request({
    url:    '/franchise/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
};

function update(id, values) {
  return request({
    url:    `/franchise/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
};

function remove(id) {
  return request({
    url:    `/franchise/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
};

function filter(params) {
  return request({
    url:    '/franchise/filter',
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params: params
  });
};

const StoreService = {
  list, listAll,  find, save, update, remove, filter
};

export default StoreService;
